export const RECENT_ROWS = [3, 5, 8] as const;
